module.exports = __webpack_public_path__ + "img/21ccd90.png";